<agpr-dialog-container
    [id]="id"
    heading="Briefings.briefingSaveTemplateDialog.saveDialogHeading"
    [modal]="true"
    [draggable]="false"
    [contentPadding]="false"
    (close)="cancel()"
>
    <div
        class="agpr-briefingSaveTemplateDialog-content"
        role="radiogroup"
        [attr.aria-label]="'Briefings.briefingSaveTemplateDialog.saveDialogOptions' | localize"
    >
        <div class="agpr-briefingSaveTemplateDialog-inputGroup">
            <agpr-radio
                [id]="id + '_createRadio'"
                class="agpr-briefingSaveTemplateDialog-radio"
                [value]="saveTemplateState.NEW"
                [(ngModel)]="saveType"
                (ngModelChange)="validate()"
                name="save_options"
                label="Briefings.briefingSaveTemplateDialog.saveAsNewLabel"
                hiddenLabel="Briefings.briefingSaveTemplateDialog.saveAsNewLabel"
            ></agpr-radio>
            <agpr-text-input
                [id]="id + '_newStyleNameInput'"
                class='agpr-input agpr-briefingSaveTemplateDialog-newNameInput'
                ariaLabel="Briefings.briefingSaveTemplateDialog.saveAsNewPlaceholder"
                [(ngModel)]="newBriefingTemplateName"
                (ngModelChange)="validate()"
                [placeholder]="'Briefings.briefingSaveTemplateDialog.saveAsNewPlaceholder' | localize"
                [maxLength]="64"
                [bottomMargin]="false"
                [disabled]="saveType === saveTemplateState.UPDATE"
            ></agpr-text-input>
        </div>

        <div class="agpr-briefingSaveTemplateDialog-inputGroup">
            <agpr-radio
                [id]="id + '_updateRadio'"
                class="agpr-briefingSaveTemplateDialog-radio"
                [value]="saveTemplateState.UPDATE"
                [(ngModel)]="saveType"
                (ngModelChange)="validate()"
                name="save_options"
                label="Briefings.briefingSaveTemplateDialog.updateExistingLabel"
                hiddenLabel="Briefings.briefingSaveTemplateDialog.updateExistingLabel"
            ></agpr-radio>
            <div class="agpr-inputGroupRow">
                <agpr-dropdown
                    [id]="id + '_updateDropdown'"
                    class="agpr-inputGroupRow-dropdown"
                    placeholder="Briefings.briefingSaveTemplateDialog.updateExistingPlaceholder"
                    [disabled]="saveType === saveTemplateState.NEW"
                    [(ngModel)]="existingBriefingTemplateDropdown"
                    (ngModelChange)="validate()"
                    [options]="briefingTemplateListItems"
                    optionLabel="name"
                    ariaLabel="Briefings.briefingSaveTemplateDialog.updateExistingLabel"
                ></agpr-dropdown>
                <agpr-button
                    [id]="id + '_manageTemplates'"
                    class="agpr-inputGroupRow-buttons"
                    icon="fa-regular fa-duotone fa-gear"
                    tooltip="Briefings.manageTemplates"
                    [style]="buttonTypes.icon"
                    (click)="openManageTemplatesDialog()"
                ></agpr-button>
            </div>
        </div>

        <div class="agpr-briefingSaveTemplateDialog-templateContent">
            <div class="agpr-briefingSaveTemplateDialog-templateContentLabel">
                {{ 'Briefings.briefingSaveTemplateDialog.setTemplateContent' | localize}}
            </div>
            <div class="agpr-briefingSaveTemplateDialog-templateContentOptionsContainer">
                <agpr-scroll-panel>
                    <div class="agpr-briefingSaveTemplateDialog-templateContentOptions">
                        <agpr-tree-list
                            [hideParentCheckbox]="false"
                            [items]="templateOptions"
                            [(selection)]="selectedOptions"
                            (selectionChange)="handleOptionChange()"
                        ></agpr-tree-list>
                    </div>
                </agpr-scroll-panel>
            </div>
        </div>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '_cancelButton'"
            label="Core.button.cancel"
            [style]="buttonTypes.secondary"
            (click)="closeDialog();"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        @if (saveType === saveTemplateState.NEW) {
            <agpr-button
                [id]="id + '_createButton'"
                label="Briefings.saveTemplateDialog.createLabel"
                [style]="buttonTypes.primary"
                (click)="create()"
                [disabled]="!formValid"
            ></agpr-button>
        } @else if (saveType === saveTemplateState.UPDATE) {
            <agpr-button
                [id]="id + '_updateButton'"
                label="Briefings.saveTemplateDialog.updateLabel"
                [style]="buttonTypes.primary"
                (click)="update()"
                [disabled]="!formValid"
            ></agpr-button>
        }
    </ng-template>
</agpr-dialog-container>
